/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../../../src/app/components/client/shared/components/code-sample.module';
import * as i2 from '@angular/common';
export const CodeSampleModuleNgFactory:i0.NgModuleFactory<i1.CodeSampleModule> = i0.ɵcmf(i1.CodeSampleModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,([] as any[])],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,
          i2.NgLocalization,i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(512,i2.CommonModule,
          i2.CommonModule,([] as any[])),i0.ɵmpd(512,i1.CodeSampleModule,i1.CodeSampleModule,
          ([] as any[]))]);
    });
const styles_CodeSampleComponent:any[] = ['[_nghost-%COMP%] {\n			display: block;\n		}\n\n		[_nghost-%COMP%]     .prettyprint code .code-missing {\n			color: #c3002f;\n		}'];
export const RenderType_CodeSampleComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_CodeSampleComponent,data:{}});
export function View_CodeSampleComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[i0.ɵqud(402653184,1,{codeContainer:0}),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),1,'pre',[['class','prettyprint linenums']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(0,[[1,0],['codeContainer',
      1]],(null as any),0,'code',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any)))],(null as any),(null as any));
}
export function View_CodeSampleComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'code-sample',
      ([] as any[]),(null as any),(null as any),(null as any),View_CodeSampleComponent_0,
      RenderType_CodeSampleComponent)),i0.ɵdid(4243456,(null as any),0,i1.CodeSampleComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const CodeSampleComponentNgFactory:i0.ComponentFactory<i1.CodeSampleComponent> = i0.ɵccf('code-sample',
    i1.CodeSampleComponent,View_CodeSampleComponent_Host_0,{language:'language',code:'code'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zaGFyZWQvY29tcG9uZW50cy9jb2RlLXNhbXBsZS5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvY2xpZW50L3NoYXJlZC9jb21wb25lbnRzL2NvZGUtc2FtcGxlLm1vZHVsZS50cyIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zaGFyZWQvY29tcG9uZW50cy9jb2RlLXNhbXBsZS5tb2R1bGUudHMuQ29kZVNhbXBsZUNvbXBvbmVudC5odG1sIiwibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvY2xpZW50L3NoYXJlZC9jb21wb25lbnRzL2NvZGUtc2FtcGxlLm1vZHVsZS50cy5Db2RlU2FtcGxlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHByZSBjbGFzcz1cInByZXR0eXByaW50IGxpbmVudW1zXCI+PGNvZGUgI2NvZGVDb250YWluZXI+PC9jb2RlPjwvcHJlPiIsIjxjb2RlLXNhbXBsZT48L2NvZGUtc2FtcGxlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzJEQ0FBO01BQUE7TUFBQSw0Q0FBa0M7TUFBQTtNQUFBOzs7b0JDQWxDO01BQUE7b0NBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/client/shared/components/code-sample.module.ngfactory.ts